module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_5010.d46d1d2c.png";